import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { Link } from 'react-router-dom'
import './DemandDetailPage.scss'
import CommentList from '../../Components/Commons/CommentList'
import ResultForm from '../../Components/Demand/ResultForm'
import $ from 'jquery'
import jQuery from 'jquery'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import {
    RoleStr,
    renderFiles,
    renderPDFFiles,
    renderImageFiles,
    renderOfficeFiles,
    renderVideoFiles,
} from '../../Components/Commons/Utils'

class DemandDetailPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            demand: null,
            resultForm: false,
            user: null,
            deletePop: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        this.loadUser()
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ user: res.data })
                this.loadDemand()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadDemand = () => {
        axios
            .get(`${BACKEND_HOST}/rfis/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ demand: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteDemand = () => {
        axios
            .delete(`${BACKEND_HOST}/rfis/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res)
                this.setState({
                    deletePop: false,
                })
                window.location.href = '/demand/'
            })
            .catch((err) => {
                console.log(err)
            })
    }

    openResult = () => {
        this.setState({
            resultForm: true,
        })
    }

    closeResult = () => {
        this.setState({
            resultForm: false,
        })
    }

    render() {
        console.log(this.state)

        if (this.state.demand) {
            //날짜 변환
            const newDate = new Date(this.state.demand.createdAt)
            const newYear = newDate.getFullYear()
            const week = new Array('일', '월', '화', '수', '목', '금', '토')
            const newDayName = week[newDate.getDay()]

            let newMonth = newDate.getMonth() + 1
            if (newMonth < 10) {
                newMonth = '0' + newMonth
            }
            let newDay = newDate.getDate()
            if (newDay < 10) {
                newDay = '0' + newDay
            }
            let newHours = newDate.getHours()
            if (newHours < 10) {
                newHours = '0' + newHours
            }
            let newMinutes = newDate.getMinutes()
            if (newMinutes < 10) {
                newMinutes = '0' + newMinutes
            }

            let assignee = ''
            if (this.state.demand.assignee) {
                assignee = this.state.demand.assignee.name
            } else {
                assignee = '지정안됨'
            }

            return (
                <div>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div className="demand_detail_wrap common_detail">
                            <div className="section">
                                <div className="top_wrap">
                                    <div className="page_name">요청사항</div>
                                    <h1>{this.state.demand.title}</h1>
                                    <div className="writer_wrap">
                                        <p className="title">작성자</p>
                                        <p className="name">{this.state.demand.writer.name}</p>
                                        <ul className="date">
                                            <li>
                                                {newYear}.{newMonth}.{newDay}({newDayName})
                                            </li>
                                            <li className="line"></li>
                                            <li>
                                                {newHours}:{newMinutes}
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="charger_wrap">
                                        <p className="title">담당자</p>
                                        <p className="name">{assignee}</p>
                                    </div>
                                </div>
                                {this.state.demand.files && this.state.demand.files.length !== 0 && (
                                    <div className="text_wrap">
                                        <div className="content">{renderFiles(this.state.demand.files)}</div>
                                    </div>
                                )}
                                {this.state.demand.files && this.state.demand.files.length !== 0 && (
                                    <div className="text_wrap">
                                        <div className="video_content">{renderVideoFiles(this.state.demand.files)}</div>
                                    </div>
                                )}
                                {this.state.demand.files && this.state.demand.files.length !== 0 && (
                                    <div className="text_wrap">
                                        <div className="content">{renderPDFFiles(this.state.demand.files)}</div>
                                    </div>
                                )}
                                {this.state.demand.files && this.state.demand.files.length !== 0 && (
                                    <div className="text_wrap">
                                        <div className="content">{renderOfficeFiles(this.state.demand.files)}</div>
                                    </div>
                                )}
                                {this.state.demand.files && this.state.demand.files.length !== 0 && (
                                    <div className="text_wrap">
                                        <div className="content">{renderImageFiles(this.state.demand.files)}</div>
                                    </div>
                                )}
                                <div className="detail_content_wrap">
                                    <div
                                        className="inner_html"
                                        dangerouslySetInnerHTML={{ __html: this.state.demand.content }}></div>
                                </div>
                                {this.state.demand.status === 'READY' &&
                                    this.state.user &&
                                    this.state.user._id === this.state.demand.writer_id && (
                                        <ul className="btn_wrap">
                                            <li
                                                className="gray_btn_s"
                                                onClick={() => this.setState({ deletePop: true })}>
                                                삭제
                                            </li>
                                            <Link to={`/demand/write/${this.props.match.params.id}`}>
                                                <li className="green_btn_s">수정</li>
                                            </Link>
                                        </ul>
                                    )}

                                {this.state.deletePop && (
                                    <div className="alret_pop2_bg">
                                        <div className="alret_pop2_wrap">
                                            <p className="h1_text">삭제하시겠습니까?</p>
                                            <p>삭제하면 복원할 수 없습니다.</p>
                                            <div
                                                className="btn btn1"
                                                onClick={() => this.setState({ deletePop: false })}>
                                                아니오
                                            </div>
                                            <div className="btn btn2" onClick={() => this.deleteDemand()}>
                                                네
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <CommentList
                                    project_id={this.state.demand._project}
                                    id={this.props.match.params.id}
                                    page={'client_request'}
                                    url={'RFI'}
                                />

                                {/* 답변은 caas에서만 등록 하도록 하플에서 막음 */}
                                {/* {this.state.resultForm === false &&
                                    this.state.demand.status === 'READY' &&
                                    this.state.demand.assignee &&
                                    this.state.user._id === this.state.demand.assignee._id && (
                                        <div onClick={this.openResult}>
                                            <div className="full_btn_pc pc_v">처리결과 등록</div>
                                            <div className="full_btn_m mobile_v">처리결과 등록</div>
                                        </div>
                                    )} */}
                            </div>
                            {this.state.resultForm === true && (
                                <ResultForm
                                    project_id={this.state.demand.project_id}
                                    demand={this.state.demand}
                                    closeResult={this.closeResult}
                                    id={this.props.match.params.id}
                                    user={this.state.user}
                                    disabled={false}
                                    history={this.props.history}
                                />
                            )}

                            {this.state.demand.response.createdAt && (
                                <ResultForm
                                    project_id={this.state.demand.project_id}
                                    demand={this.state.demand}
                                    closeResult={this.closeResult}
                                    id={this.props.match.params.id}
                                    user={this.state.user}
                                    disabled={true}
                                    history={this.props.history}
                                />
                            )}

                            <Link to={`/demand/`}>
                                <div className="list_btn">
                                    목록
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#6D7075"
                                            strokeLinecap="round"
                                            strokeWidth="1.2">
                                            <path d="M.674 1H9.32M.674 4.06h6.277M.674 7.06h8.65" />
                                        </g>
                                    </svg>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap"></div>
            </div>
        )
    }
}

export default DemandDetailPage



// WEBPACK FOOTER //
// ./Src/Containers/Demand/DemandDetailPage.js